import React, {Component} from 'react'
import {connect} from 'react-redux'

import ViewerContainer from '../viewers/viewer-container'
import DefaultSearchForm from '../form/default-search-form'

import NarrativeRoutingResults from '../narrative/narrative-routing-results'
import {getShowUserSettings} from '../../@opentripplanner/core-utils/src/state'
import TabbedFormPanel from "../form/tabbed-form-panel";
import {Box} from "@mui/material";
import Stack from "@mui/material/Stack";
import JourneyBar from "../form/journey-bar";

class DefaultMainPanel extends Component {
  render() {
    const {
      customIcons,
      itineraryClass,
      itineraryFooter,
      icons
      , dir
      , config
    } = this.props
    
    // Check for headless mode
    const urlParams = new URLSearchParams(window.location.search);
    const isHeadless = urlParams.get('headless') === 'true';
    
  //  const showPlanTripButton = mainPanelContent === 'EDIT_DATETIME' || mainPanelContent === 'EDIT_SETTINGS'
    //const mostRecentQuery = activeSearch ? activeSearch.query : null
  //  const planDisabled = isEqual(currentQuery, mostRecentQuery)
    return (
      <ViewerContainer>
        <div style={{
          position: 'relative'
        }}>
          <Box>
            <Stack direction="column" spacing={isHeadless ? 1 : 2} alignItems="flex-start" justifyContent="flex-start">
              {config.showJourneyBar && <JourneyBar/>}
              <Box sx={{width: '100%'}}>
                <DefaultSearchForm icons={customIcons}/>
              </Box>
              <Box sx={{width: '100%'}}>
                <TabbedFormPanel icons={icons}/>
              </Box>
            </Stack>
          </Box>
          <div className='desktop-narrative-container'>
            <NarrativeRoutingResults
              itineraryClass={itineraryClass}
              itineraryFooter={itineraryFooter}
              customIcons={customIcons}
              dir={dir}/>
          </div>
        </div>
      </ViewerContainer>
    )
  }
}
/*    {!activeSearch && !showPlanTripButton && showUserSettings &&
            <UserSettings />
          }*/

// connect to the redux store
const mapStateToProps = (state, ownProps) => {
  const showUserSettings = getShowUserSettings(state.otp)
  return {
    config: state.otp.config,
    currentQuery: state.otp.currentQuery,
    mainPanelContent: state.otp.ui.mainPanelContent,
    dir:state.otp.config.dir,
    showUserSettings
  }
}

const mapDispatchToProps = { }

export default connect(mapStateToProps, mapDispatchToProps)(DefaultMainPanel)
